import { ReactNode } from 'react'

import styles from './RadioButton.module.scss'

export interface RadioCircleProps {
  selected: boolean
  className?: string
}

export const RadioCircle = ({ selected, className }: RadioCircleProps) => (
  <span className={`${styles.radioCircle} ${selected ? styles.radioCircleSelected : ''} ${className ?? ''}`} />
)

export interface RadioButtonProps {
  label: string
  selected: boolean
  onClick: () => void
  children?: ReactNode
  className?: string
  disabled?: boolean
}

const RadioButton = ({ label, selected, onClick, children, className, disabled = false }: RadioButtonProps) => {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      disabled={disabled}
      className={`${styles.radioOption} ${selected ? styles.radioOptionSelected : ''} ${disabled ? styles.radioOptionDisabled : ''} ${className ?? ''}`}
      onClick={onClick}
    >
      <span className={styles.radioHeader}>
        <RadioCircle selected={selected} />
        <span className={styles.radioLabel}>{label}</span>
      </span>
      {children && <span onClick={(event) => event.stopPropagation()}>{children}</span>}
    </button>
  )
}

export default RadioButton
